/**
 * InsightsIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const InsightsIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.375 15.375h-2.25C3.504 15.375 3 15.879 3 16.5V21h4.5v-4.5c0-.621-.504-1.125-1.125-1.125m6.75-5.625h-2.25c-.621 0-1.125.504-1.125 1.125V21h4.5V10.875c0-.621-.504-1.125-1.125-1.125M19.875 3h-2.25c-.621 0-1.125.504-1.125 1.125V21H21V4.125C21 3.504 20.496 3 19.875 3" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const InsightsIcon = makeIcon('InsightsIcon', InsightsIconSvg)
